import { getAddressComponents } from "./utils/getAddressComponents.js";
import { isValidateAddressProps, validateAddress__ } from "./utils/validateAddress__.js";
const validateAddress = (result) => {
  const addr = isValidateAddressProps(result) ? result : getAddressComponents(result);
  return validateAddress__(addr);
};
export {
  validateAddress
};
//# sourceMappingURL=validateAddress.js.map
